export { default } from './TicketCardSkeleton';
